/* eslint-disable */
import libraries from "../arduino/libraries";

export default function init(Blockly, profile) {
    Blockly.Arduino.ledmatrix = {};

    Blockly.Arduino.ledmatrix_init = function () {

        Blockly.Arduino.includes_.push(libraries.adafruit_gfx);
        Blockly.Arduino.includes_.push(libraries.adafruit_led_backpack);
        Blockly.Arduino.includes_.push(libraries.adafruit_busio);

        var a = this.getFieldValue("ADDR"),
            b = this.getFieldValue("ID");

        Blockly.Arduino.definitions_.define_wire = "#include <Wire.h>";
        Blockly.Arduino.definitions_.define_adafruit_gfx = "#include <Adafruit_GFX.h>";
        Blockly.Arduino.definitions_.define_ledmatrix = "#include <Adafruit_LEDBackpack.h>";
        Blockly.Arduino.definitions_["var_ledmatrix_" + b] = "Adafruit_8x8matrix ledmatrix_" + b + " = Adafruit_8x8matrix();";
        Blockly.Arduino.setups_["setup_ledmatrix_" + b] = "  ledmatrix_" + b + ".begin(" + a + "); \n  ledmatrix_" + b + ".setTextWrap(false);\n  ledmatrix_" + b + ".setTextSize(1);\n";
        return ""
    };
    Blockly.Arduino.ledmatrix_clear = function() {
        if (!Blockly.Arduino.definitions_.define_ledmatrix) return "";
        var a = this.getFieldValue("ID");
        return "ledmatrix_" + a + ".clear();\nledmatrix_" + a + ".writeDisplay();\n"
    };
    Blockly.Arduino.ledmatrix_drawpixel = function() {
        if (!Blockly.Arduino.definitions_.define_ledmatrix) return "";
        var a = this.getFieldValue("ID"),
            b = Blockly.Arduino.valueToCode(this, "X", Blockly.Arduino.ORDER_ATOMIC),
            c = Blockly.Arduino.valueToCode(this, "Y", Blockly.Arduino.ORDER_ATOMIC),
            d = this.getFieldValue("COL");
        return "ledmatrix_" + a + ".drawPixel(" + b + ", " + c + ", " + d + ");\nledmatrix_" + a + ".writeDisplay();\n"
    };
    Blockly.Arduino.ledmatrix_drawline = function() {
        if (!Blockly.Arduino.definitions_.define_ledmatrix) return "";
        var a = this.getFieldValue("ID"),
            b = Blockly.Arduino.valueToCode(this, "X1", Blockly.Arduino.ORDER_ATOMIC),
            c = Blockly.Arduino.valueToCode(this, "Y1", Blockly.Arduino.ORDER_ATOMIC),
            d = Blockly.Arduino.valueToCode(this, "X2", Blockly.Arduino.ORDER_ATOMIC),
            e = Blockly.Arduino.valueToCode(this, "Y2", Blockly.Arduino.ORDER_ATOMIC),
            f = this.getFieldValue("COL");
        return "ledmatrix_" + a + ".drawLine(" + b + ", " + c + ", " + d + ", " + e + ", " +
            f + ");\nledmatrix_" + a + ".writeDisplay();\n"
    };
    Blockly.Arduino.ledmatrix_drawrectangle = function() {
        if (!Blockly.Arduino.definitions_.define_ledmatrix) return "";
        var a = this.getFieldValue("ID"),
            b = Blockly.Arduino.valueToCode(this, "X1", Blockly.Arduino.ORDER_ATOMIC),
            c = Blockly.Arduino.valueToCode(this, "Y1", Blockly.Arduino.ORDER_ATOMIC),
            d = Blockly.Arduino.valueToCode(this, "X2", Blockly.Arduino.ORDER_ATOMIC),
            e = Blockly.Arduino.valueToCode(this, "Y2", Blockly.Arduino.ORDER_ATOMIC),
            f = this.getFieldValue("COL"),
            g = "drawRect";
        "TRUE" == this.getFieldValue("FILL") && (g =
            "fillRect");
        return "ledmatrix_" + a + "." + g + "(" + b + ", " + c + ", " + d + ", " + e + ", " + f + ");\nledmatrix_" + a + ".writeDisplay();\n"
    };
    Blockly.Arduino.ledmatrix_drawcircle = function() {
        if (!Blockly.Arduino.definitions_.define_ledmatrix) return "";
        var a = this.getFieldValue("ID"),
            b = Blockly.Arduino.valueToCode(this, "X", Blockly.Arduino.ORDER_ATOMIC),
            c = Blockly.Arduino.valueToCode(this, "Y", Blockly.Arduino.ORDER_ATOMIC),
            d = Blockly.Arduino.valueToCode(this, "R", Blockly.Arduino.ORDER_ATOMIC),
            e = this.getFieldValue("COL"),
            f = "drawCircle";
        "TRUE" == this.getFieldValue("FILL") && (f = "fillCircle");
        return "ledmatrix_" + a + "." + f + "(" + b + ", " + c + ", " + d + ", " + e + ");\nledmatrix_" +
            a + ".writeDisplay();\n"
    };
    Blockly.Arduino.ledmatrix_drawtext = function() {
        if (!Blockly.Arduino.definitions_.define_ledmatrix) return "";
        var a = Blockly.Arduino.valueToCode(this, "TXT", Blockly.Arduino.ORDER_ATOMIC) || "''",
            b = this.getFieldValue("ID"),
            c = Blockly.Arduino.valueToCode(this, "X", Blockly.Arduino.ORDER_ATOMIC),
            d = Blockly.Arduino.valueToCode(this, "Y", Blockly.Arduino.ORDER_ATOMIC);
        this.getFieldValue("COL");
        return "ledmatrix_" + b + ".setCursor(" + c + ", " + d + ");\nledmatrix_" + b + ".print(" + a + ");\nledmatrix_" + b + ".writeDisplay();\n"
    };
    Blockly.Arduino.ledmatrix_drawbitmap = function() {
        if (!Blockly.Arduino.definitions_.define_ledmatrix) return "";
        var a = this.getFieldValue("DATA"),
            b = this.getFieldValue("ID");
        Blockly.Arduino.definitions_["var_ledmatrixdata_" + Blockly.Arduino.ledmatrix_count] =
        "static const uint8_t PROGMEM ledmatrix_data_" + Blockly.Arduino.ledmatrix_count + "[] PROGMEM = {" + a + "};";
        a = "ledmatrix_" + b + ".clear();\n" +
            "ledmatrix_" + b + ".drawBitmap(0, 0, ledmatrix_data_" + Blockly.Arduino.ledmatrix_count + ", 8, 8, LED_ON);\n" +
            "ledmatrix_" + b + ".writeDisplay();\n";
        Blockly.Arduino.ledmatrix_count++;
        return a
    };
    Blockly.Arduino.ledmatrix_drawsprite = function() {
        var a = this.getFieldValue("ID"),
            b = this.getFieldValue("SPRITE"),
            c = "",
            d = "";
        "face_happy" == b && (c = "B00000000,B00100100,B00100100,B00100100,B00000000,B01000010,B00111100,B00000000");
        "face_sad" == b && (c = "B00000000,B10100101,B01000010,B00000000,B00111100,B01111110,B11000011,B00000000");
        "face_angry" == b && (c = "B01000010,B10100101,B10011001,B10011001,B01100110,B00000000,B00000000,B00111100");
        "icon_heart" == b && (c = "B00000000,B01100110,B11111111,B11111111,B01111110,B00111100,B00011000,B00000000");
        "icon_arrowU" == b && (c = "B00011000,B00111100,B01111110,B11111111,B00111100,B00111100,B00111100,B00111100");
        "icon_arrowD" == b && (c = "B00111100,B00111100,B00111100,B00111100,B11111111,B01111110,B00111100,B00011000");
        "icon_arrowL" == b && (c = "B00010000,B00110000,B01111111,B11111111,B11111111,B01111111,B00110000,B00010000");
        "icon_arrowR" == b && (c = "B00001000,B00001100,B11111110,B11111111,B11111111,B11111110,B00001100,B00001000");
        "icon_ray" == b && (c = "B01110000,B10001110,B10011001,B10010001,B10000001,B01111110,B00101010,B01010100");
        "icon_moon" == b && (c = "B00011111,B00111000,B01110000,B01110000,B01110000,B01110000,B00111000,B00011111");
        "icon_cloud" == b && (c = "B00000000,B01110000,B10001110,B10011001,B10010001,B10000001,B01111110,B00000000");
        "icon_forbidden" == b && (c = "B00111100,B01000010,B10000001,B10111101,B10111101,B10000001,B01000010,B00111100");
        "icon_infinite" == b && (c = "B00000000,B00000000,B01100110,B10011001,B10011001,B01100110,B00000000,B00000000");
        "icon_look_left" == b && (c = "B00000000,B01001000,B01101100,B00000000,B00000001,B00000011,B01111110,B00111100");
        "icon_look_right" == b && (c = "B00000000,B00010010,B00110110,B00000000,B10000000,B11000000,B01111110,B00111100");
        "icon_note" == b && (c = "B00000000,B00111110,B00100010,B00100010,B00100010,B01100110,B01100110,B00000000");
        "icon_ok" == b && (c = "B00000000,B01101001,B10011010,B10011100,B10011100,B10011010,B01101001,B00000000");
        "icon_ouch" == b && (c = "B10000001,B01000010,B00100100,B01000010,B10000001,B00111100,B01000010,B10000001");
        "icon_plus" == b && (c = "B00011000,B00011000,B00011000,B11111111,B11111111,B00011000,B00011000,B00011000");
        "icon_question" == b && (c = "B00000010,B00000101,B11100000,B00000000,B00000000,B00000000,B01111110,B00000000");
        "icon_serious" == b && (c = "B00000000,B00100100,B00100100,B00100100,B00000000,B00000000,B01111110,B00000000");
        "icon_smile" == b && (c = "B00100100,B00100100,B00000000,B11111111,B10000001,B10000001,B01000010,B00111100");
        "icon_sun" == b && (c = "B10010001,B01000010,B00011000,B00111101,B10111100,B00011000,B01000010,B10001001");
        "icon_surpirsed" == b && (c = "B01100110,B10011001,B10011001,B01100110,B00000000,B00011000,B00111100,B00011000");
        "icon_tic" == b && (c = "B00000000,B00000001,B00000011,B10000111,B11001110,B01111100,B00111000,B00010000");
        "icon_unhappy" == b && (c = "B00000000,B00100100,B00100100,B00100100,B00000000,B00000000,B00111100,B01000010");
        "icon_yummy" == b && (c = "B00100100,B00100100,B00000000,B10000010,B11000110,B01111110,B00111111,B00000011");
        "" != c && (Blockly.Arduino.definitions_["var_ledmatrixdata_sprite_" + b] =
        "static const uint8_t PROGMEM ledmatrix_data_sprite_" + b + "[] PROGMEM = {" + c + "};",
        d = "ledmatrix_" + a + ".clear();\n" +
            "ledmatrix_" + a + ".drawBitmap(0, 0, ledmatrix_data_sprite_" + b + ", 8, 8, LED_ON);\n" +
            "ledmatrix_" + a + ".writeDisplay();\n");
        return d
    };
    Blockly.Arduino.ledmatrix_rotation = function() {
        if (!Blockly.Arduino.definitions_.define_ledmatrix) return "";
        var a = this.getFieldValue("ID"),
            b = this.getFieldValue("ROT");
        return "ledmatrix_" + a + ".setRotation(" + b + ");\n"
    };
    Blockly.Arduino.ledmatrix_show = function() {
        return Blockly.Arduino.definitions_.define_ledmatrix ? "ledmatrix_" + this.getFieldValue("ID") + ".writeDisplay();\n" : ""
    };
    Blockly.Arduino.ledmatrix_drawmatrix = function() {
        if (!Blockly.Arduino.definitions_.define_ledmatrix) return "";
        var id = this.getFieldValue("ID");
        var count = Blockly.Arduino.ledmatrix_count2.toString();
        var code = "";
        for (var d = 0; 8 > d; d++) {
            for (var e = "  B", f = 0; 8 > f; f++) {
                e = "TRUE" == this.getFieldValue("R" + d.toString() + "C" + f.toString()) ? e + "1" : e + "0";
            }
            code += e;
            7 <= d && 7 <= f || (code += ",\n")
        }
        Blockly.Arduino.definitions_["var_ledmatrixmatrix_" + count] =
            "static const uint8_t PROGMEM ledmatrix_matrix_" +
            count + "[] PROGMEM = {\n" + code + "};";
        Blockly.Arduino.ledmatrix_count2++;
        return "ledmatrix_" +
                id +
                ".clear();\nledmatrix_" +
                id +
                ".drawBitmap(0, 0, ledmatrix_matrix_" + count + ", 8, 8, LED_ON);\nledmatrix_" + id + ".writeDisplay();\n"
    };
}
